<template>
  <module-page v-bind="pageParams" :customBreadcrumbs="customBreadcrumbs">
    <v-layout row wrap style="justify-content: space-between">
      <v-flex xs12 md7 lg7>
        <v-tabs class="page__tabs" hide-slider v-model="selectedTab">
          <v-tab
            v-for="(tab, j) in pageParams.tabs"
            :to="tab.value"
            :key="j"
            active-class="support--background white--text"
          >
            {{
              tab.title.mobile
                ? mobile
                  ? tab.title.mobile
                  : tab.title.notMobile
                : tab.title
            }}
          </v-tab>
        </v-tabs>
        <screen-loading v-if="supportLoading"></screen-loading>
        <div v-else class="mt-2 mb-5">
          <div v-if="supportError" class="empty-state">
            {{ enums.responses.error }}
          </div>
          <template v-else>
            <v-expansion-panel expand>
              <expansion-panel
                icon-class-modifier="support--color"
                class="gray-expansion"
              >
                <div slot="header" class="in-analysis--color">
                  Em análise ({{ inAnalysis.length }})
                </div>
                <div slot="content">
                  <ticket-card
                    :key="k"
                    v-for="(item, k) in inAnalysis"
                    :statusParams="enums.ticketStatus"
                    :item="item"
                    @edit="editTicket"
                  ></ticket-card>
                </div>
              </expansion-panel>
              <expansion-panel
                icon-class-modifier="support--color"
                class="gray-expansion"
              >
                <div slot="header" class="waiting-reply--color">
                  Aguardando sua resposta ({{ waitingReply.length }})
                </div>
                <div slot="content">
                  <ticket-card
                    :key="k"
                    v-for="(item, k) in waitingReply"
                    :statusParams="enums.ticketStatus"
                    :item="item"
                    @edit="editTicket"
                  ></ticket-card>
                </div>
              </expansion-panel>
              <expansion-panel
                icon-class-modifier="support--color"
                class="gray-expansion"
              >
                <div slot="header" class="in-progress--color">
                  Em andamento ({{ inProgress.length }})
                </div>
                <div slot="content">
                  <ticket-card
                    :key="k"
                    v-for="(item, k) in inProgress"
                    :statusParams="enums.ticketStatus"
                    :item="item"
                    @edit="editTicket"
                  ></ticket-card>
                </div>
              </expansion-panel>
              <expansion-panel
                icon-class-modifier="support--color"
                class="gray-expansion"
              >
                <div slot="header" class="done--color">
                  Finalizado ({{ done.length }})
                </div>
                <div slot="content">
                  <ticket-card
                    :key="k"
                    v-for="(item, k) in done"
                    :statusParams="enums.ticketStatus"
                    :item="item"
                    @edit="editTicket"
                  ></ticket-card>
                </div>
              </expansion-panel>
            </v-expansion-panel>
          </template>
        </div>
      </v-flex>
      <v-flex xs12 md4 lg4 class="mt-4 mb-4">
        <faq-card
          :items="faqItems"
          :loading="faqLoading"
          :error="faqError"
          :params="faqCardParams"
          :errorText="enums.responses.error"
          @faqSelected="goToFaq"
          :retryFunction="getFaqs"
        ></faq-card>
      </v-flex>
    </v-layout>
  </module-page>
</template>

<script>
import bus from '../../../utils/bus';
import { APP } from '@/utils/constants';
import faqMixin from '../../../mixins/modules/faq';
import supportMixin from '../../../mixins/modules/support';
import ModulePage from '@/components/layout/Page';
import ExpansionPanel from '@/components/layout/ExpansionPanel';
import FaqCard from '@/components/modules/FaqCard';
import SelectField from '@/components/fields/Select';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import TicketCard from '@/components/support/TicketCard';
import moment from 'moment-timezone';

import 'moment/locale/pt-br';

moment.locale('pt-BR');

export default {
  name: 'ticket-list',
  mixins: [faqMixin, supportMixin],
  components: {
    ModulePage,
    ExpansionPanel,
    FaqCard,
    SelectField,
    ScreenLoading,
    TicketCard,
  },
  computed: {
    customBreadcrumbs() {
      const path = this.$route.path;
      const tab = this.pageParams.tabs.find((tab) => tab.value == path);
      if (tab) {
        const title = tab.title.mobile
          ? this.mobile
            ? tab.title.mobile
            : tab.title.notMobile
          : tab.title;
        return [{ text: title }];
      } else {
        return [{ text: 'Atendimento' }];
      }
    },
    inAnalysis() {
      return this.supportItems.inAnalysis; //.filter(i => i.lastDateUpdate > this.initialDateFilter)
    },
    inProgress() {
      return this.supportItems.inProgress; //.filter(i => i.lastDateUpdate > this.initialDateFilter)
    },
    waitingReply() {
      return this.supportItems.waitingReply; //.filter(i => i.lastDateUpdate > this.initialDateFilter)
    },
    done() {
      return this.supportItems.done; //.filter(i => i.lastDateUpdate > this.initialDateFilter)
    },
    initialDateFormated() {
      return moment(this.initialDateFilter).format('L');
    },
  },
  data() {
    return {
      pageParams: this.$store.getters[APP.PAGES].support,
      faqCardParams: this.$store.getters[APP.APP_MODULES].faq,
      selectedTab: '',
      initialDateMenu: false,
      initialDateFilter: moment().subtract(3, 'months').toISOString(),
    };
  },
  created() {
    bus.$on('unit:change', this.getItems);
    bus.$on('unit:update', this.getItems);

    this.getFaqs();
    this.getItems();
  },
  beforeDestroy() {
    bus.$off('unit:change', this.getItems);
    bus.$off('unit:update', this.getItems);
  },
  methods: {
    getItems(unitObj = null) {
      this.getOctadeskAllProposersTickets();
    },
    editTicket({ number, id }) {
      this.$router.push({
        name: 'ticketDetails',
        params: { number, id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/breakpoint';

.in-analysis--color {
  color: #3dcdce;
}
.waiting-reply--color {
  color: #ffc271;
}
.in-progress--color {
  color: #3db347;
}
.done--color {
  color: #bcbcbc;
}

.gray-expansion {
  >>> .v-expansion-panel__container--active {
    background-color: #eeeeee !important;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/support/ticket/TicketList.vue